module.exports = __webpack_public_path__ + "static/cars_fr-1f499ac946df6c706b66ee45d06822a2.jpg";